module.exports = __webpack_public_path__ + "static/media/logo.aca3ef64.png";